export default __webpack_public_path__ + "static/media/dccFalse.d812e936.png";